module.exports = __webpack_public_path__ + "static/media/samw.2158b3e5.png";